//
// Generated class APPCC_TaskResult
//

/// <reference path="APPCC_TaskResult_ManagedObject.ts" />

class APPCC_TaskResult extends APPCC_TaskResult_ManagedObject
{

}
